import React from 'react';
import { Card, Timeline, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../Shared/GlobalContext/ThemeContext';
import { formatFullTime } from '../../../../utils/messageRenderUtils';

const { Text } = Typography;

const MessageEditHistory = ({ editHistory, currentContent }) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    if (!editHistory || editHistory.length === 0) return null;

    const themeColors = {
        cardBackground: isDarkMode ? '#1f1f1f' : '#fff',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.65)' : 'rgba(0, 0, 0, 0.45)',
    };

    return (
        <Card title={t('edit_history')} style={{ background: themeColors.cardBackground }}>
            <Timeline>
                {editHistory.map((edit, index) => (
                    <Timeline.Item key={index}>
                        <Text style={{ color: themeColors.text }}>"{edit.content}"</Text>
                        <br />
                        <Text type="secondary" style={{ color: themeColors.secondaryText }}>{formatFullTime(edit.edited_at)}</Text>
                    </Timeline.Item>
                ))}
                <Timeline.Item>
                    <Text style={{ color: themeColors.text }}>"{currentContent}" ({t('current')})</Text>
                </Timeline.Item>
            </Timeline>
        </Card>
    );
};

export default MessageEditHistory;
